import type { GoogleStatus } from "../types";

type Props = {
  status: GoogleStatus;
  busy: boolean;
  onConnect: () => void;
};

export default function GoogleConnect({ status, busy, onConnect }: Props) {
  if (status.connected) return null;
  return (
    <section className="pr-card mx-auto mt-16 max-w-xl px-8 py-12 text-center">
      <p className="text-3xl font-semibold tracking-tight">Vos fiches, enfin au calme.</p>
      <p className="mx-auto mt-3 max-w-md text-sm leading-6 text-slate-500">
        Reliez le compte Google qui gère vos établissements. Horaires, avis, photos et stats se
        retrouvent ici.
      </p>
      <button type="button" disabled={busy} onClick={onConnect} className="pr-btn mt-8">
        {busy ? "Redirection…" : "Connecter Google"}
      </button>
    </section>
  );
}
